import actions from '@lib/analytics/emarsys/actions'

const { tagEvent } = actions

const sendLocation = (type: string, location: string) => {
  /* istanbul ignore next */
  if (location?.length) {
    tagEvent(`${type}-selection`, { location })
  }
}

export default {
  sendLocation,
}
